/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/presentationList.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_SECTION_OPTION } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { pretty } from "@vlinder-web/utils-react";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IInventoryMethods extends IPluginMethodMap {
  getInventoryProps(args: any): Promise<any>;
}

export class InventoryService implements IAgentPlugin {
  readonly methods: IInventoryMethods;

  constructor() {
    this.methods = {
      getInventoryProps: this.getInventoryProps.bind(this),
    };
  }

  async getInventoryProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    if (args?.vid === true) {
      args.vid = "-"
    }
    let addOnFilter = {};
    if (args?.fid) {
      addOnFilter = {
        _id: { eq: args?.fid },
      };
    }
    if (args?.vid && args?.vid !== "-") {
      addOnFilter = { ...addOnFilter, CV___name: { eq: args?.vid } };
    }
    if (args?.att && args?.att !== "-") {
      addOnFilter = { ...addOnFilter, CA___name: { eq: args?.att } };
    }
    try {
      if (client) {
        const res = await client.query({
          query: GET_SECTION_OPTION,
          variables: {
            filters: {
              costumeType: {
                eq: args?.id,
              },
              ...addOnFilter,
            },
            options: {
              limit: args?.size ?? 10,
              skip: args?.offset ?? 0,
            },
            // filter:{
            //   _id:args?.id
            // }
          },
          fetchPolicy: "network-only",
        });

        if (res?.data) {
          let _totalPages = res?.data?.getFullCostumeFeatureInventories?.count
            ? parseInt(res?.data?.getFullCostumeFeatureInventories?.count) / 10
            : 1;

          let _currentPage =
            (res?.data?.getFullCostumeFeatureInventories?.skip +
              res?.data?.getFullCostumeFeatureInventories?.limit) /
            res?.data?.getFullCostumeFeatureInventories?.pageSize;

          let _rowData = this.formatTable(
            res?.data?.getFullCostumeFeatureInventories?.content,
            //  res?.data?.getCostumeType?.costumeFeatures,
            args?.fid
          );
          // let _totalPages = _rowData.length/10;

          return {
            ...config,
            ultUsers: _rowData,
            isEmpty: _rowData.length <= 0,
            // studentGroup: holderGroups,
            activePage: _currentPage,
            pageSize: Math.min(
              _rowData.length,
              res?.data?.getFullCostumeFeatureInventories?.limit
            ),
            totalCount: res?.data?.getFullCostumeFeatureInventories?.count,
            totalPages: _totalPages,
            ...this.breadcrumbItems(
              res?.data?.getFullCostumeFeatureInventories?.content
            ),
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }

  private breadcrumbItems(costumeFeatures: any[]) {
    let data = {
      section: "",
      sectionOption: "",
      presentation: ""
    };
    if (costumeFeatures?.length > 0) {
      data.section = costumeFeatures[0]?.section?.name;
      data.sectionOption = costumeFeatures[0]?.costumeType?.name;
      data.presentation = costumeFeatures[0]?.presentation?.name;
    }
    return data;
  }

  private formatTable(costumeFeatures: any[], fid?: any): any[] {
    let _rowData: any = [];
    costumeFeatures?.forEach((item) => {
      _rowData.push({
        valueName: `${item?.CV?.name ?? "-"}`,
        id: item?.CV.id ?? "-",
        featureName: item.name ?? "-",
        attributeName: item?.CA?.name ?? "-",
        inventory: item?.CVInventory ?? 0,
        featureId: item.id,
        registered: item.registered ?? 0,
        remaining: item.remaining ?? 0,
      });
    });
    return _rowData;
  }
}
